// src/pages/Inicio.js
import React from 'react';
import ExcelUploader from '../Funciones/ExcelUploader';
import ExcelEditor from '../Funciones/ExcelEditor';
import ExcelTabla from '../Funciones/ExcelTabla';
import TimeSeriesChart from '../Funciones/TimeSeriesChart';
import ExcelBusqueda from '../Funciones/ExcelBusqueda';
import PDFViewer from '../Funciones/PDFViewer';
import TablaPDF from '../Funciones/TablaPdf';

const Inicio = () => 
<div>
    <div>
        <p className="m-2"><b>N°1</b> Cargar Tabla excel</p>
        <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"1000px", height:"800px"}} >
          <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
             <ExcelUploader/>
          </div>
        </div>
    </div>
    <hr className="mt-3 mb-2"/>
     {/*---------------------------------------------------------------------------------------- */}
     <div>
        <p className="m-2"><b>N°2</b> Cargar Formato excel</p>
        <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"1000px", height:"700px"}} >
          <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
             <ExcelEditor/>
          </div>
        </div>
    </div>
    <hr className="mt-3 mb-2"/>
     {/*---------------------------------------------------------------------------------------- */}
     
      <div>
        <p className="m-2"><b>N°3</b> Graficar numeros por teclado</p>
        <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"1000px", height:"700px"}} >
          <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
            <TimeSeriesChart/>
          </div>
        </div>
    </div>
    <hr className="mt-3 mb-2"/>
     {/*---------------------------------------------------------------------------------------- */}
      {/*---------------------------------------------------------------------------------------- */}
     
      <div>
        <p className="m-2"><b>N°4</b> Realizar Búsquedas en PDF</p>
        <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"1000px", height:"1370px"}} >
          <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
            <PDFViewer/>
          </div>
        </div>
    </div>
    <hr className="mt-3 mb-2"/>
     {/*---------------------------------------------------------------------------------------- */}
     <div>
        <p className="m-2"><b>N°5</b> Exportar Tabla</p>
        <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"1000px", height:"700px"}} >
          <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
           
          </div>
        </div>
    </div>
    <hr className="mt-3 mb-2"/>
     {/*---------------------------------------------------------------------------------------- */}
</div>;
export default Inicio;